var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSummaryIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.59375 0H5.90625C3.12202 0 1.7299 -2.01166e-07 0.864953 0.864953C-2.01166e-07 1.7299 0 3.12202 0 5.90625V9.70312C0 12.4873 -2.01166e-07 13.8794 0.864953 14.7444C1.7299 15.6094 3.12202 15.6094 5.90625 15.6094H7.59375C10.378 15.6094 11.7701 15.6094 12.6351 14.7444C13.5 13.8794 13.5 12.4873 13.5 9.70312V5.90625C13.5 3.12202 13.5 1.7299 12.6351 0.864945C11.7701 -2.01166e-07 10.378 0 7.59375 0Z",
    fill: "#B9BBC2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.375 9.70312H6.75M3.375 6.32812H10.125",
    stroke: "#546088",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryIc);
export default __webpack_public_path__ + "static/media/summary_ic.7e924e65026d6bbc6bac7001765348ab.svg";
export { ForwardRef as ReactComponent };